import { render } from "./ConsumptionDayChart.vue?vue&type=template&id=0caa3e30"
import script from "./ConsumptionDayChart.vue?vue&type=script&lang=js"
export * from "./ConsumptionDayChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__